import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

function stringToColor(string: string, index: number = 0) {
  const input = `${index}-${string}`;

  let hash = 0;

  for (let i = 0; i < input.length; i++) {
    hash = input.charCodeAt(i) + ((hash << 3) - hash);
    hash |= 0; // force 32-bit int
  }

  const hue = Math.abs(hash) % 360;

  // Slight natural variation
  const saturation = 50 + (Math.abs(hash >> 1) % 20); // 65–85%
  const lightness = 50 + (Math.abs(hash >> 4) % 10); // 50–60%

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

function stringAvatar(name: string, index: number = 0) {
  return {
    sx: {
      bgcolor: stringToColor(name, index),
    },
    children: `${name}`,
  };
}

const userTestimonials = [
  {
    avatar: <Avatar {...stringAvatar("K.N")} />,
    name: "K.Nさん",
    testimonial:
      "自分のプラクティカルシューティングについての考え方、戦略のレベルとは次元の違うレベルの話を教えて頂き、大変勉強になると共に、これまでより上のレベルに行けるという強いモチベーションを得ることが出来た。\n競技への理解が深まることで、競技の楽しさを再発見、再確認することができたのも大きく、日本でプラクティカルシューティングを広めていく上で重要なことを学べたと感じる。\n個人的には、プラクティカルシューティングの個々の要素（ワンハンドシュート、足場が不安定な状態での射撃等）についてさらに知りたいと思った。\n次回開催時には是非参加したい。",
  },
  {
    avatar: <Avatar {...stringAvatar("P")} />,
    name: "Pさん",
    testimonial:
      "講習会では、一人ひとりの癖や直したほうがいいところを個別に教えていただけたのがすごく嬉しかったです！\n海外で結果を出されている方の射撃を間近で見ることができて、それだけでも参加して良かったなと思いました。\nまた、普段なかなか一緒に練習することのないレベルの高い方々と同じ場で練習できたのも、とても勉強になりました。見ているだけでも学ぶことが多かったです！\n懇親会では、練習中には聞けないアメリカの今の銃業界のSNSの話、参考になる海外の女性シューターのことなども教えていただけて、とてもありがたかったです！\n同じ趣味を持つ方々と交流できたことで、他にも行ってみたいシューティング練習会を知ることができたのも嬉しかったです！\n本当にありがとうございました😊！",
  },
  {
    avatar: <Avatar {...stringAvatar("T.T")} />,
    name: "T.Tさん",
    testimonial:
      "今回の講習会ではスインガーの攻略方法が特に印象にのこりました。\n今までスインガーは上手くいったらラッキーくらいの認識でした。\nなので、攻略法があるとは思っておらず非常に驚きました。もし、次回も参加させていただける様であれば今回のスインガーの様に攻略を諦めていた事なども聞いていければと思いました。\nこの度も参加させていただきありがとうございました。",
  },
  {
    avatar: <Avatar {...stringAvatar("I.T")} />,
    name: "I.Tさん",
    testimonial:
      "3回目まで受講できて本当によかったです！ \n毎回の授業で違うテーマを聞けて、得られた知識の量が本当に10年以上ショートカットしたほど多いです。\n磨きたい技術点がまだ山ほどありますので、ぜひ次回も参加させていただきたいです。",
  },
  {
    avatar: <Avatar {...stringAvatar("T.M")} />,
    name: "T. Mさん",
    testimonial:
      "今回は個別に指導してもらえる時間を多くとってもらえてすごくよかったと思います。\nその分、時間が経つのが早く短かったと感じました。\n講習内容も的を絞り深く説明してもらえてより理解することができたと思います。\n他の人へのアドバイス内容も聞いていて参考になり、充実した時間を過ごせました。\nまた開催するのでしたらぜひ参加させてもらいたいと思います。",
  },
  {
    avatar: <Avatar {...stringAvatar("M.M")} />,
    name: "M.Mさん",
    testimonial:
      "コースを見て戦略を立てること（速さを取るか／正確さをとるかといった判断など）は、まだまだスムーズにできませんが、まずは教えていただいたアクションシューティングの基礎となる目や身体の使い方を20日の練習会でも出来るようにしたいと思います。",
  },
  {
    avatar: <Avatar {...stringAvatar("S.M")} />,
    name: "S.Mさん",
    testimonial:
      "射撃や移動の技術だけでなく、コース攻略についても学ぶことができてよかったです。もし機会があればまた参加したいと思います。",
  },
  {
    avatar: <Avatar {...stringAvatar("K.N", 1)} />,
    name: "K.Nさん",
    testimonial:
      "次回開催されれば是非参加したいです。将来的にアリゾナでの個人レッスンも依頼したいです。",
  },
  {
    avatar: <Avatar {...stringAvatar("H.S")} />,
    name: "H.Sさん",
    testimonial:
      "「こんな機会もうないかも」の想いで参加しました。自分の技術をもっと上げないと次の課題が見えてこないと分かったので、指摘された改善点を意識して練習し、試合で結果を出して行かないとならんと思った次第です。次回も声をかけてもらうために上手くなります。",
  },
];

export default function Testimonials() {
  return (
    <Container
      id="testimonials"
      sx={{
        py: 3,
        alignItems: "center",
        width: { xs: "100%", lg: "120%" },
        mx: { lg: "-10%" },
        gap: 3,
      }}
    >
      <Grid container spacing={2}>
        {userTestimonials.map((testimonial, index) => (
          <Grid
            size={{ xs: 12, sm: 6, md: 4 }}
            key={index}
            sx={{ display: "flex" }}
          >
            <Card
              variant="outlined"
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                flexGrow: 1,
              }}
            >
              <CardContent>
                <Typography
                  variant="body1"
                  gutterBottom
                  sx={{ color: "text.secondary", whiteSpace: "pre-line" }}
                >
                  {testimonial.testimonial}
                </Typography>
              </CardContent>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <CardHeader
                  avatar={testimonial.avatar}
                  title={testimonial.name}
                />
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
